const Eth = require('ethjs')
const SignerProvider = require('ethjs-provider-signer')
const sign = require('ethjs-signer').sign
const contracts = require('./dpos_abi')
const url = process.env.NODE_ENV === "production" ? "/api" : "/api";


const eth = new Eth(new SignerProvider(url, {
  signTransaction: (rawTx, cb) => {
    cb(null, sign(rawTx, accounts[0].secretKey))
  },
  accounts: cb => cb(null, [accounts[0].address])
}))

module.exports = {
  Eth,
  eth,
  contracts
}
